module.exports = __webpack_public_path__ + "static/media/health8.9460dcd3.svg";